import Sortable from "sortablejs";

document.addEventListener("turbo:load", () => {
  const sortableLists = document.querySelectorAll(".sortable");

  // Exit early if there are no sortable lists on the page
  if (sortableLists.length === 0) return;

  sortableLists.forEach((el) => {
    const parentForm = el.closest("form");
    const isAutoReorderForm = parentForm && parentForm.classList.contains("auto_reorder");

    new Sortable(el, {
      group: "shared",
      animation: 150,
      onAdd: (evt) => {
        updateHiddenFieldNames(evt);
        updateEmptyListPlaceholders();
      },
      onRemove: updateEmptyListPlaceholders,
      onEnd: (evt) => {
        updateEmptyListPlaceholders(evt);

        if (isAutoReorderForm) {
          console.log("Auto reorder triggered → submitting form");
          parentForm.requestSubmit();
        }
      },
    });
  });

  updateEmptyListPlaceholders();

  // Optional: Only attach form listener if debugging on pages that need it
  document.addEventListener("submit", (e) => {
    console.log("Form submitted:", e.target);
  });
});

function updateEmptyListPlaceholders() {
  document.querySelectorAll(".sortable").forEach((list) => {
    const parentForm = list.closest("form");
    const isAutoReorderForm = parentForm && parentForm.classList.contains("auto_reorder");
    if (isAutoReorderForm) return; // skip auto reorder lists

    let placeholder = list.querySelector(".empty-placeholder");
    const hasItems = list.querySelectorAll(".sortable-item").length > 0;

    if (!hasItems) {
      if (!placeholder) {
        placeholder = document.createElement("li");
        placeholder.className =
          "empty-placeholder text-center text-muted py-2 border rounded bg-light";
        placeholder.textContent = "No items in list";
        list.appendChild(placeholder);
      }
    } else if (placeholder) {
      placeholder.remove();
    }
  });
}

function updateHiddenFieldNames(evt) {
  const item = evt.item;                // <li>
  const newList = evt.to;               // <ul>
  const fieldName = newList.dataset.fname;

  if (!fieldName) return;

  item.querySelectorAll("input[type='hidden']").forEach((input) => {
    input.name = `${fieldName}[]`;
  });
}